import React from 'react';
import './BlazinAttachment.scss';
import { usePager } from '../../../helpers/pagination';
import PageIndicator from '../../Common/PageIndicator';
import LeaderBoardRow from './LeaderBoardRow';
export const LeaderBoardComponent = ({
  employees,
  duration,
  playing,
  accent_color
}) => {
  const [page, pageIdx, pages] = usePager(employees, duration * 1000, playing);
  return /*#__PURE__*/React.createElement("div", {
    className: "attachment-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header"
  }, /*#__PURE__*/React.createElement("p", {
    className: "header-location"
  }, "Employee"), /*#__PURE__*/React.createElement("p", {
    className: "header-location"
  }, "Attachment")), page.map((employee, index) => /*#__PURE__*/React.createElement(LeaderBoardRow, {
    key: index,
    employee: employee
  })), /*#__PURE__*/React.createElement("div", {
    className: "page-indicator"
  }, pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  })));
};